module.exports = __webpack_public_path__ + "assets/img/mecha-e3f91301.png";